import '../i18n/i18n';
import '../styles/category.scss';

import { ColourTheme } from '../types/ColourTheme';
import { Layout } from '../hoc/Layout/Layout';
import { PersonaTemplate } from '../components/Colours/PersonaTemplate/PersonaTemplate';
import React from 'react';
import i18n from 'i18next';

class Home extends React.PureComponent {
  render() {
    return (
      <Layout
        metaTitle={i18n.t('tabs.coloursMicro')}
        metaDesc={i18n.t('metadescr.coloursMicro.anna')}
        theme={ColourTheme.cerulean}
      >
        <PersonaTemplate theme={ColourTheme.cerulean} />
      </Layout>
    );
  }
}

export default Home;